import React from "react";

const About = () => {
  return (
    <div className="ltn__about-us-area pt-90 pb-90 about2-sec">
      <div className="pr-7">
        <div className="row">
          <div className="col-lg-6 align-self-center about-left">
            <div className="about-us-img-wrap about-img-left">
              <video
                autoPlay
                muted
                loop
                className="about1-video about-us-video"
              >
                <source
                  src="/assets/img/selfmade/videos/about.mp4"
                  type="video/mp4"
                />
              </video>
              <img
                src="/assets/img//home-page-video-pic.jpg"
                className="about-us-mobile-image"
                alt="About Us"
              // style={{ display: "none" }}
              />
            </div>
          </div>
          <div className="col-lg-6 align-self-center about-right ">
            <div className="about-us-info-wrap">
              <div className="section-title-area ltn__section-title-2--- mb-20">
                <h6 className="section-subtitle section-subtitle-2 ">
                  About Us
                </h6>
                <h1
                  className="section-title about1-title"
                  style={{ lineHeight: "100%" }}
                >
                  Explore Canada's Top Rated{" "}
                  <span>Vehicle Maintenance Plans</span>
                </h1>
                <p>
                </p>
              </div>
              <div className="ltn__callout mt-30">
                <p className="text-justify mb-4">
                  Extended Trust is a dealership-focused platform that enables the creation and management of custom maintenance packages tailored to each customer and vehicle. Our system streamlines service planning, tracks vehicle history, and centralizes customer data in one easy-to-use platform.
                </p>
                <p className="text-justify mb-4">
                  By simplifying how maintenance programs are built and delivered, we help dealerships improve service efficiency, strengthen customer retention, and enhance CSI.
                </p>
                <p className="text-justify mb-4">
                  The result is a smarter, more consistent way to manage maintenance programs while driving better long-term customer relationships and dealership performance.
                </p>
              </div>
              <div className="btn-wrapper animated go-top">
                <a href="#products" className="theme-btn-1 btn btn-effect-1">
                  OUR PRODUCTS
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="container">
        </div> */}
    </div>
  );
};

export default About;
